import React, { useState, useEffect, Fragment } from 'react';
import _ from 'underscore';
import { NoTranslate, A, BlankLink, DataTable } from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import Datetime from '../toolkit/Datetime';
import ContentRequestStatusIndicator from './ContentRequestStatusIndicator';

export default () => {
  const [data, setData] = useState([]);
  const [columns] = useState([
    {
      Header: 'Title',
      accessor: cr => cr,
      noTranslate: true,
      filter: {
        type: 'search',
        placeholder: 'Title...'
      },
      filterMethod: DataTable.filterByContaining(accessorValue => accessorValue.title),
      Cell: row => (
        <A href={`/content_requests/${row.value.id}`} title={row.value.title}>
          <NoTranslate text={row.value.title} />
        </A>
      )
    },
    {
      Header: 'Publication',
      id: 'publicationName',
      accessor: cr => cr.contentRequestForm.brandProfile.name,
      noTranslate: true,
      filter: {
        type: 'select',
        options: tableData => {
          const publicationNames = _.uniq(
            tableData.map(cr => cr.contentRequestForm.brandProfile.name)
          ).map(name => [name, name]);
          return [['All', ''], ...publicationNames];
        }
      }
    },
    {
      Header: 'Form',
      id: 'contentRequestFormName',
      accessor: 'contentRequestForm',
      Cell: row => (
        <BlankLink href={row.value.externalFormUrl} title="Content request form">
          <NoTranslate text={row.value.name} />
        </BlankLink>
      ),
      filter: {
        type: 'select',
        options: tableData => {
          const formNames = _.uniq(tableData.map(cr => cr.contentRequestForm.name)).map(name => [
            name,
            name
          ]);
          return [['All', ''], ...formNames];
        }
      },
      filterMethod: DataTable.filterByExactly(accessorValue => accessorValue.name),
      sortMethod: DataTable.sortBy(accessorValue => accessorValue.name)
    },
    {
      Header: 'Submitter',
      id: 'submitter',
      accessor: 'externalUser',
      Cell: row => <NoTranslate>{`${row.value.fullName} (${row.value.email})`}</NoTranslate>,
      filter: {
        type: 'search',
        placeholder: 'Name...'
      },
      filterMethod: DataTable.filterByContaining(
        accessorValue => accessorValue.fullName,
        accessorValue => accessorValue.email
      )
    },
    {
      Header: 'Date of submission',
      accessor: 'createdAt',
      Cell: row => <Datetime timestamp={row.value} formatType="date" />
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: cr => ({ status: cr.status, statusHumanize: cr.statusHumanize }),
      Cell: ContentRequestStatusIndicator,
      filter: {
        type: 'select',
        options: [
          ['All', ''],
          ['Accepted', 'accepted'],
          ['Declined', 'declined'],
          ['Awaiting review', 'awaiting_review']
        ]
      },
      filterMethod: DataTable.filterByExactly(accessorValue => accessorValue.status),
      sortMethod: DataTable.sortBy(accessorValue => accessorValue.status)
    }
  ]);

  const fetchData = async () => setData(await get('/api/v1/content_requests'));
  useEffect(() => {
    fetchData();
  }, []);
  if (!data.length) return <Fragment />;

  return (
    <div className="content-wrapper-inner">
      <DataTable.Table data={data} columns={columns} recordNoun="content request" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_requests/content_requests.jsx